import { defineComponent as n, openBlock as r, createBlock as l, unref as p, mergeProps as m, withCtx as s, createElementVNode as a } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const i = /* @__PURE__ */ n({
  name: "IconTrash",
  __name: "IconTrash",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (r(), l(p(v), m(t, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        a("path", { d: "M14.65 8.75a.75.75 0 0 0-1.5 0v9a.75.75 0 1 0 1.5 0v-9M9.9 8a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0v-9A.75.75 0 0 1 9.9 8" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M9.166 5a1 1 0 0 1 .006-.093 2.75 2.75 0 0 1 5.458 0A1 1 0 0 1 14.635 5H19.6a.75.75 0 1 1 0 1.5h-.948v12.75a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25V6.5H4.4a.75.75 0 1 1 0-1.5h4.765m3.96 0a1.25 1.25 0 0 0-2.45 0h2.45M6.65 6.5h10.5v12.75A.75.75 0 0 1 16.4 20h-9a.75.75 0 0 1-.75-.75V6.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  i as default
};
